<section id="home" class="landing">
	<div class="shadow">
		<div class="container">
			<div class="landing-content">
				<h2>Ven a vivir la experiencia <span>Tiny House</span></h2>
				<p>
					Si buscas una estadía en conexión con la naturaleza en la
					localidad de Malalcahuello, la encontraras en nuestras Tiny
					House. Buscamos con este espacio novedoso y versátil, un
					turismo sustentable, en el cual puedas disfrutar y cuidar el
					medio ambiente al mismo tiempo. Visita Malacahuello y
					alójate en una Tiny House.
				</p>
				<a
					class="btn btn-reserva"
					href="https://wa.me/56996796708?text=Me%20interesa%20saber%20mas%20sobre%20las%20Tiny%20Houses%20🌱"
					target="_blank"
					title="Contacto"
					rel="noopener noreferrer">Reserva aquí</a
				>
			</div>
		</div>
	</div>
</section>

<style lang="scss">
	@import "../scss/responsive";

	.landing {
		background-image: url(/img/landing/landing_background_2x.jpg);
		background-image: -webkit-image-set(
			url(/img/landing/landing_background_2x.webp)
		);
		@media only screen and (min-width: 640px) {
			background-image: url(/img/landing/landing_background_2x.jpg);
			background-image: -webkit-image-set(
				url(/img/landing/landing_background_2x.webp)
			);
		}
		@media only screen and (min-width: 1280px) {
			background-image: url(/img/landing/landing_background_3x.jpg);
			background-image: -webkit-image-set(
				url(/img/landing/landing_background_3x.webp)
			);
		}
		@media only screen and (min-width: 1920px) {
			background-image: url(/img/landing/landing_background_4x.jpg);
			background-image: -webkit-image-set(
				url(/img/landing/landing_background_4x.webp)
			);
		}
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 50%;
		color: #fff;
		min-height: 100vh;
		width: 100%;

		.landing-content {
			@include responsive {
				width: 50%;
			}
		}
	}

	.shadow {
		background-color: rgba(0, 0, 0, 0.2);
		height: 100vh;
		display: flex;
		align-items: center;
	}

	h2 {
		font-family: "mansalva", sans-serif;
		font-size: 48px;
		span {
			font-size: 72px;
			display: block;
		}
	}

	p {
		font-size: 1.2rem;
		line-height: 1.6rem;
		margin-bottom: 1rem;
		@include responsive {
			font-size: 1.2rem;
		}
	}

	.btn {
		text-transform: uppercase;
		font-size: 1.25rem;
		max-width: 100%;

		@include responsive {
			max-width: 320px;
		}
	}
</style>
